import React from "react";
import Section from "../Section";
import BlogSectionStyle2 from "../Section/BlogSection/BlogSectionStyle2";
import Breadcrumb from "../Breadcrumb";
import { pageTitle } from "../../helpers/PageTitle";
import { Helmet } from "react-helmet";
const blogData = [
  {
    title: "Symptoms before period: important information",
    thumbUrl: "images/blog/post_1.jpeg",
    date: "March 12 , 2024",
    btnText: "Learn More",
    href: "/blog/blog-details",
    socialShare: true,
  },
];

export default function Blog() {
  pageTitle("Blog");
  return (
    <>
      <Helmet>
        <title>
          Video Blogs – Expert IVF Guidance | Jabalpur Fertility Centre
        </title>
        {/* Meta Description */}
        <meta
          name="description"
          content="Watch IVF video blogs by Jabalpur Fertility Centre’s experts. Learn about fertility treatments, pregnancy care, and success stories."
        />
        {/* Meta Keywords */}
        <meta
          name="Keywords"
          content="IVF video blogs, fertility clinic Jabalpur, IVF tips, pregnancy advice, fertility treatment videos, Jabalpur IVF Centre"
        />
        {/* Robots Tag */}
        <meta name="robots" content="index, follow" />

        {/* Author */}
        <meta name="author" content="Jabalpur Fertility Centre" />

        {/* Publisher */}
        <meta name="publisher" content="Jabalpur Fertility Centre" />
        <link
          rel="canonical"
          href="https://jabalpurivfcentre.com/video-blogs"
        />
      </Helmet>
      <Section topMd={170} bottomMd={96} bottomLg={70}>
        <Breadcrumb title="Understanding the Psychological and Lifestyle Aspects" />
      </Section>
      <Section bottomMd={200} bottomLg={150} bottomXl={110}>
        <BlogSectionStyle2 data={blogData} />
      </Section>
    </>
  );
}
